import { render, staticRenderFns, recyclableRender, components } from "./empty.vue?vue&type=template&id=4c25cea0&scoped=true&"
var renderjs
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"
import style0 from "./empty.vue?vue&type=style&index=0&id=4c25cea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25cea0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/empty/empty.vue"
export default component.exports